import type { ComponentChildren } from 'preact'
import { useState } from 'preact/hooks'
import type { RoomState } from '../types'
import type { SlateSpeaker } from './ViewerSlate'
import { ViewerWaitingBand } from './ViewerWaitingBand'

interface ViewerWaitingImageProps {
    url: string
    room: Pick<RoomState, 'StartUtc' | 'TimeZone'>
    speakers: SlateSpeaker[]
    now: number
    /** The slate without the image, when the image cannot be loaded. */
    fallback: ComponentChildren
}

/**
 * The holding slate with the image the web shows instead of a waiting video (ORB-1118): the image in the video's 16:9
 * box, whole and letterboxed on the slate's colour so a slide's text is never cropped, with the countdown and presenters
 * in the same band under it. Nothing plays, so there are no controls. An image that fails to load gives way to the plain
 * slate. Marked decorative, since the Room tab asks for no description: the band carries what a viewer must know.
 */
export function ViewerWaitingImage({ url, room, speakers, now, fallback }: ViewerWaitingImageProps) {
    const [failed, setFailed] = useState(false)
    if (failed) return <>{fallback}</>

    return (
        <div class="v-wait">
            <div class="v-wait-video">
                <img class="v-wait-img" src={url} alt="" onError={() => setFailed(true)} />
            </div>
            <ViewerWaitingBand room={room} speakers={speakers} now={now} />
        </div>
    )
}
